import React, {useCallback, useState} from 'react';

export function useSelectKeyboardControl({listLength}: {listLength: number}) {
	const [focusedIndex, setFocusedIndex] = useState(-1);

	// Set focused item in suggest list on keyboard control
	const handleKeyboardControlEvent = useCallback(
		(event: React.KeyboardEvent | KeyboardEvent) => {
			let delta;
			if (event.key === 'ArrowUp') {
				delta = -1;
			} else if (event.key === 'ArrowDown') {
				delta = 1;
			}

			if (!delta) {
				return;
			}

			event.preventDefault();

			const maxIndex = listLength - 1;
			let newIndex = focusedIndex + delta;
			if (newIndex < 0) {
				newIndex = maxIndex;
			} else if (newIndex > maxIndex) {
				newIndex = 0;
			}
			setFocusedIndex(newIndex);
		},
		[focusedIndex, listLength],
	);

	const handleFocusIndexReset = useCallback(() => setFocusedIndex(-1), []);

	return {
		focusedIndex,
		handleKeyboardControlEvent,
		handleFocusIndexReset,
		setFocusedIndex,
	};
}

useSelectKeyboardControl.displayName = 'useSelectKeyboardControl';
